<template lang="pug">
  v-card.schedule-list-empty
    svg.schedule-list-empty__icon
      use(xlink:href="/svg/sprite.svg#icon-schedules")
    h2.schedule-list-empty__title {{ 'base.loadings_list_empty' | translate }}
    v-btn(:disabled="!hasPermission('loading', 'add')" @click="modal.showCreatePlanning = true") {{ 'schedule.add_load' | translate }}
    v-dialog(
      max-width="400"
      v-model="modal.showCreatePlanning")
      create-planning-modal(
        @close="modal.showCreatePlanning = false")
</template>

<script>
import CreatePlanningModal from './dialogs/CreatePlanningModal'

export default {
  name: 'ListEmpty',

  components: {
    CreatePlanningModal
  },

  data: () => ({
    modal: {
      showCreatePlanning: false
    }
  })
}
</script>

<style lang="scss" scoped>
  @import '@/sass/abstracts/_mixins.scss';

  .schedule-list-empty {
    position: relative;
    height: 48rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &__icon {
      position: absolute;
      height: 33rem;
      width: 33rem;
      opacity: 0.05;
      left: 8rem;
      top: 50%;
      transform: translateY(-50%);

      @include mobile {
        width: 28rem;
        height: 28rem;
        left: 4rem;
      }
    }

    &__title {
      font-size: 2.4rem;
      font-weight: 700;
      margin-bottom: 3rem;
    }
  }
</style>
